import React, { Component } from "react"
import PropTypes from "prop-types"

import { Dropdown } from "ui"
import RenderBlockTypeAttributes from "features/editor/attributes/RenderBlockTypeAttributes"

class DropdownAttribute extends Component {
    render() {
        const { options, onChange, value, ...otherProps } = this.props
        return (
            <Dropdown
                className="interactive"
                onChange={this.props.onChange}
                options={options}
                value={value || ""}
                {...RenderBlockTypeAttributes.cleanUpProps(otherProps)}
            />
        )
    }
}

DropdownAttribute.propTypes = {
    multiline: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
}

export default DropdownAttribute



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/form/Dropdown.js